import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLingui } from '@lingui/react';

const SITE_NAME = 'EVOXX Equipamentos';

const resolvePageTitle = (title, i18n) => {
  if (!title) {
    return null;
  }

  if (typeof title === 'string') {
    return title;
  }

  const { id, values, message, children } = title.props || {};

  if (id) {
    return i18n._(id, values, { message: message ?? children });
  }

  if (typeof children === 'string') {
    return children;
  }

  return null;
};

const HtmlHeader = ({ title, description }) => {
  const { i18n } = useLingui();
  const pageTitle = resolvePageTitle(title, i18n);
  const documentTitle = pageTitle ? `${pageTitle} - ${SITE_NAME}` : SITE_NAME;

  return (
    <Helmet>
      <title>{documentTitle}</title>
      <meta name="author" content="Lima Labs — https://www.limalabs.co" />
      {description ? <meta name="description" content={description} /> : null}
    </Helmet>
  );
};

export default React.memo(HtmlHeader);
